<template src="./Searchbar.html"></template>
<style src="./Searchbar.scss" lang="scss"></style>

<script>
	import Input from '@/components/Input/Input';
	import { Helper } from '@/services/helper/helper';

	/**
	 * The searchbar with button in the homepage.
	 * @vue-data {Object} searchbarInput An object representing the input bar for search
	 * @vue-data {string} searchURL The endpoint where searchbar should lead to
	 * @vue-data {Object} trackParams An object representing tracking parameters for search, suggest and layer
	 * @vue-data {number} suggestIndex The chosen suggest link
	 */
	export default {
		name: 'HpSearchbar',
		data () {
			return {
				searchbarInput: {
					htmlId: 'searchbar' + this._uid,
					inputType: 'search',
					ariaPlaceholder: 'google', // for identifying search machine
					inputvalue: '',
					name: 'q',
					maxLength: 1024,
					suggest: {
						id: this.$store.state.contentData.searchbar.suggestContainerId,
						url: this.$store.state.contentData.searchbar.suggestAPI,
						response: ''
					}
				},
				searchURL: this.$store.state.contentData.searchbar.searchURL,
				trackParams: this.$store.state.contentData.searchbar.trackParams,
				suggestIndex: -1
			};
		},
		methods: {
			/**
			 * Submits search to given endpoint.
			 * @param {Event} event The submit event fired by form
			 */
			searchSubmit (event) {
				event.preventDefault();
				const form = this.$el.querySelector('form') || '';

				if (!form) {
					return;
				}

				if (Helper.getElementByAttribute(this.$el, '[data-component="layer"]')) {
					form.origin.value = this.trackParams.layer
				} else {
					form.origin.value = this.suggestIndex < 0 ? this.trackParams.default : this.trackParams.suggest
				}
				form.submit();
			},
			/**
			 * Clears input value of search form.
			 */
			searchReset () {
				let form = this.$el.querySelector('form') || '';
				form && form.reset();
				this.searchbarInput.inputvalue = '';
			},
			/**
			 * Gets index of focused or chosen suggest link.
			 * @param obj The object representing search suggest link
			 */
			getSuggestIndex (obj) {
				this.suggestIndex = obj.index;
			},
			getKonami () {
				let keysPressed = '';
				const konamiCode = '38384040373937396665';

				this.$el.addEventListener('keyup', (event) => {
					switch (event.keyCode) {
						case 38:
						case 40:
						case 37:
						case 39:
						case 66:
						case 65:
							keysPressed += event.keyCode;
							break;
						case 27:
						default:
							keysPressed = '';
					}

					if (keysPressed === konamiCode) {
						let searchForm = event.currentTarget.querySelector('[data-component="searchbar"] form');

						if (searchForm) {
							let searchBar = searchForm.querySelector('input[id^="searchbar"]');
							if (searchBar) {
								searchBar.value = 'Konami Code';
								searchForm.submit();
							}
						}
					} else if (keysPressed.length >= konamiCode.length) {
						keysPressed = '';
					}
				});
			}
		},
		components: {
			'hp-input': Input
		},
		mounted () {
			this.getKonami();
		}
	};
</script>
